/* ====================================================
商品ページ JS
2026-05-15 sp_specialized.js をベースに作成

【変更点】
- IIFE で囲んでグローバル汚染防止
- 初回読み込み時にも一度実行
- 750px以上でフリーリキッドを画像エリアに移動
- ウィンドウリサイズ時に位置を切り替え

【2026-05-22 修正】
- shopify-sectionラッパーごとではなく、section.customだけを移動するように変更
- Shopifyの「HTML壊れている検出」を回避
==================================================== */

(function() {
  'use strict';
  
  // ============================
  // フェードイン(スクロール)
  // ============================
  const fadeInOnScroll = function() {
    const target = document.getElementsByClassName('js-scroll-trigger');
    const position = Math.floor(window.innerHeight * 1.0);
    
    for (let i = 0; i < target.length; i++) {
      const offsetTop = Math.floor(target[i].getBoundingClientRect().top);
      
      if (offsetTop < position) {
        target[i].classList.add('is-animated');
      }
    }
  };
  
  window.addEventListener('scroll', fadeInOnScroll, false);
  document.addEventListener('DOMContentLoaded', fadeInOnScroll);
  
  // ============================
  // フリーリキッドの元の位置を保存
  // ============================
  let customSectionOriginalParent = null;
  let customSectionOriginalNextSibling = null;
  
  // ============================
  // フリーリキッドの位置を切り替え
  // ============================
  const toggleFreeliquidPosition = function() {
    // フリーリキッド(section.custom)を取得
    const customSection = document.querySelector('.shopify-section section.custom');
    
    // 商品画像エリアを取得
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    
    if (!customSection || !mediaWrapper) {
      return;
    }
    
    // 初回:元の位置を記憶
    if (customSectionOriginalParent === null) {
      customSectionOriginalParent = customSection.parentNode;
      customSectionOriginalNextSibling = customSection.nextSibling;
    }
    
    const isLargeScreen = window.matchMedia('(min-width: 750px)').matches;
    const isInMedia = mediaWrapper.contains(customSection);
    
    if (isLargeScreen && !isInMedia) {
      // 750px以上 かつ まだ移動していない → 画像エリアに移動
      mediaWrapper.appendChild(customSection);
    } else if (!isLargeScreen && isInMedia) {
      // 749px以下 かつ 画像エリアにある → 元の位置に戻す
      if (customSectionOriginalNextSibling) {
        customSectionOriginalParent.insertBefore(customSection, customSectionOriginalNextSibling);
      } else {
        customSectionOriginalParent.appendChild(customSection);
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', toggleFreeliquidPosition);
  
  // リサイズ時の処理(過剰発火を防ぐためdebounce)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(toggleFreeliquidPosition, 200);
  });
  
})();